import { createElement } from "commonAssets/lib/createElement";
import intlTelInput from "intl-tel-input/intlTelInputWithUtils";

const COUNTRY_CODE_MAP = {
    USA: "us",
    AFG: "af",
    ALA: "ax",
    ALB: "al",
    DZA: "dz",
    ASM: "as",
    AND: "ad",
    AGO: "ao",
    AIA: "ai",
    ATA: "aq",
    ATG: "ag",
    ARG: "ar",
    ARM: "am",
    ABW: "aw",
    AUS: "au",
    AUT: "at",
    AZE: "az",
    BHS: "bs",
    BHR: "bh",
    BGD: "bd",
    BRB: "bb",
    BLR: "by",
    BEL: "be",
    BLZ: "bz",
    BEN: "bj",
    BMU: "bm",
    BTN: "bt",
    BOL: "bo",
    BES: "bq",
    BIH: "ba",
    BWA: "bw",
    BVT: "bv",
    BRA: "br",
    IOT: "io",
    BRN: "bn",
    BGR: "bg",
    BFA: "bf",
    BDI: "bi",
    KHM: "kh",
    CMR: "cm",
    CAN: "ca",
    CPV: "cv",
    CYM: "ky",
    CAF: "cf",
    TCD: "td",
    CHL: "cl",
    CHN: "cn",
    CXR: "cx",
    CCK: "cc",
    COL: "co",
    COM: "km",
    COG: "cg",
    COD: "cd",
    COK: "ck",
    CRI: "cr",
    CIV: "ci",
    HRV: "hr",
    CUB: "cu",
    CUW: "cw",
    CYP: "cy",
    CZE: "cz",
    DNK: "dk",
    DJI: "dj",
    DMA: "dm",
    DOM: "do",
    ECU: "ec",
    EGY: "eg",
    SLV: "sv",
    GNQ: "gq",
    ERI: "er",
    EST: "ee",
    ETH: "et",
    FLK: "fk",
    FRO: "fo",
    FJI: "fj",
    FIN: "fi",
    FRA: "fr",
    GUF: "gf",
    PYF: "pf",
    ATF: "tf",
    GAB: "ga",
    GMB: "gm",
    GEO: "ge",
    DEU: "de",
    GHA: "gh",
    GIB: "gi",
    GRC: "gr",
    GRL: "gl",
    GRD: "gd",
    GLP: "gp",
    GUM: "gu",
    GTM: "gt",
    GGY: "gg",
    GIN: "gn",
    GNB: "gw",
    GUY: "gy",
    HTI: "ht",
    HMD: "hm",
    VAT: "va",
    HND: "hn",
    HKG: "hk",
    HUN: "hu",
    ISL: "is",
    IND: "in",
    IDN: "id",
    IRN: "ir",
    IRQ: "iq",
    IRL: "ie",
    IMN: "im",
    ISR: "il",
    ITA: "it",
    JAM: "jm",
    JPN: "jp",
    JEY: "je",
    JOR: "jo",
    KAZ: "kz",
    KEN: "ke",
    KIR: "ki",
    PRK: "kp",
    KOR: "kr",
    KWT: "kw",
    KGZ: "kg",
    LAO: "la",
    LVA: "lv",
    LBN: "lb",
    LSO: "ls",
    LBR: "lr",
    LBY: "ly",
    LIE: "li",
    LTU: "lt",
    LUX: "lu",
    MAC: "mo",
    MKD: "mk",
    MDG: "mg",
    MWI: "mw",
    MYS: "my",
    MDV: "mv",
    MLI: "ml",
    MLT: "mt",
    MHL: "mh",
    MTQ: "mq",
    MRT: "mr",
    MUS: "mu",
    MYT: "yt",
    MEX: "mx",
    FSM: "fm",
    MDA: "md",
    MCO: "mc",
    MNG: "mn",
    MNE: "me",
    MSR: "ms",
    MAR: "ma",
    MOZ: "mz",
    MMR: "mm",
    NAM: "na",
    NRU: "nr",
    NPL: "np",
    NLD: "nl",
    NCL: "nc",
    NZL: "nz",
    NIC: "ni",
    NER: "ne",
    NGA: "ng",
    NIU: "nu",
    NFK: "nf",
    MNP: "mp",
    NOR: "no",
    OMN: "om",
    PAK: "pk",
    PLW: "pw",
    PSE: "ps",
    PAN: "pa",
    PNG: "pg",
    PRY: "py",
    PER: "pe",
    PHL: "ph",
    PCN: "pn",
    POL: "pl",
    PRT: "pt",
    PRI: "pr",
    QAT: "qa",
    REU: "re",
    ROU: "ro",
    RUS: "ru",
    RWA: "rw",
    BLM: "bl",
    SHN: "sh",
    KNA: "kn",
    LCA: "lc",
    MAF: "mf",
    SPM: "pm",
    VCT: "vc",
    WSM: "ws",
    SMR: "sm",
    STP: "st",
    SAU: "sa",
    SEN: "sn",
    SRB: "rs",
    SYC: "sc",
    SLE: "sl",
    SGP: "sg",
    SXM: "sx",
    SVK: "sk",
    SVN: "si",
    SLB: "sb",
    SOM: "so",
    ZAF: "za",
    SGS: "gs",
    SSD: "ss",
    ESP: "es",
    LKA: "lk",
    SDN: "sd",
    SUR: "sr",
    SJM: "sj",
    SWZ: "sz",
    SWE: "se",
    CHE: "ch",
    SYR: "sy",
    TWN: "tw",
    TJK: "tj",
    TZA: "tz",
    THA: "th",
    TLS: "tl",
    TGO: "tg",
    TKL: "tk",
    TON: "to",
    TTO: "tt",
    TUN: "tn",
    TUR: "tr",
    TKM: "tm",
    TCA: "tc",
    TUV: "tv",
    UGA: "ug",
    UKR: "ua",
    ARE: "ae",
    GBR: "gb",
    UMI: "um",
    URY: "uy",
    UZB: "uz",
    VUT: "vu",
    VEN: "ve",
    VNM: "vn",
    VGB: "vg",
    VIR: "vi",
    WLF: "wf",
    ESH: "eh",
    YEM: "ye",
    ZMB: "zm",
    ZWE: "zw",
};

/**
 * Web Component for International Phone Input
 *
 * Usage:
 * <intl-phone-input
 *   name="phone"
 *   country="USA"
 *   required
 *   disabled
 *   data-label="Phone Number"
 *   data-validate="phone"
 * >
 * </intl-phone-input>
 */
class IntlPhoneInput extends HTMLElement {
    /** @type {import("intl-tel-input").Iti} */
    #instance;
    /** @type {HTMLInputElement} */
    #input;

    constructor() {
        super();
        this.attachShadow({ mode: "open" });
        this.validate = this.validate.bind(this);
    }

    connectedCallback() {
        // Load the CSS file into the Shadow DOM
        this.shadowRoot.appendChild(
            createElement("link", {
                rel: "stylesheet",
                type: "text/css",
                href: "/assets/css/vendor/intlTelInput.min.css",
            })
        );

        // Load inline styles
        this.shadowRoot.appendChild(
            createElement(
                "style",
                {
                    type: "text/css",
                },
                [],
                `
                :host {
                    /* Allow UA to adapt native form controls to color scheme */
                    color-scheme: light dark;
                }
                .iti {
                    /* Adapt to Bootstrap 5.3 color-mode variables */
                    --iti-hover-color: var(--bs-tertiary-bg, rgba(0, 0, 0, 0.05));
                    --iti-border-color: var(--bs-border-color, #ccc);
                    --iti-dialcode-color: var(--bs-secondary-color, #999);
                    --iti-dropdown-bg: var(--bs-body-bg, #ffffff);
                    --iti-spacer-horizontal: 8px;
                    --iti-flag-height: 12px;
                    --iti-flag-width: 16px;
                    --iti-border-width: 1px;
                    --iti-arrow-height: 4px;
                    --iti-arrow-width: 6px;
                    --iti-triangle-border: calc(var(--iti-arrow-width) / 2);
                    --iti-arrow-padding: 6px;
                    --iti-arrow-color: var(--bs-secondary-color, #555);
                    --iti-path-flags-1x: url("/assets/img/flags.webp");
                    --iti-path-flags-2x: url("/assets/img/flags@2x.webp");
                    --iti-path-globe-1x: url("/assets/img/globe.webp");
                    --iti-path-globe-2x: url("/assets/img/globe@2x.webp");
                    --iti-flag-sprite-width: 3904px;
                    --iti-flag-sprite-height: 12px;
                    --iti-mobile-popup-margin: 30px;
                    display: block;
                }
                input {
                    background-color: transparent;
                    border: none;
                    outline: none;
                    box-shadow: none;
                    width: 100%;
                    display: block;
                    padding: 0 0 0 44px !important;
                    font-size: 1rem;
                    font-weight: 400;
                    line-height: 1.5;
                    color: var(--bs-body-color, #212529);
                    caret-color: var(--bs-body-color, #212529);
                }
                /* Dropdown + list colors (shadow DOM, not affected by page CSS without these) */
                .iti__country-list {
                    background-color: var(--iti-dropdown-bg);
                    color: var(--bs-body-color, #212529);
                    border-color: var(--bs-border-color, #dee2e6);
                }
                .iti__dial-code,
                .iti__country-name {
                    color: inherit;
                }
                .iti__country:hover,
                .iti__country.iti__highlight {
                    background-color: var(--iti-hover-color);
                }
                .iti__divider {
                    border-color: var(--bs-border-color, #dee2e6);
                }
            `
            )
        );

        // Create the input element
        this.#input = createElement("input", { type: "tel" });

        // Append the input element to the Shadow DOM
        this.shadowRoot.appendChild(this.#input);

        this.#instance = intlTelInput(this.#input, {
            strictMode: true,
            initialCountry: this.getAttribute("country") ?? "us",
            validationNumberTypes: null,
        });

        // Add validation event listeners
        this.#input.addEventListener("blur", this.validate);
        this.#input.addEventListener("change", this.validate);
    }

    disconnectedCallback() {
        if (this.#instance) {
            this.shadowRoot.innerHTML = "";
            this.#instance.destroy();
        }
        if (this.#input) {
            this.#input.removeEventListener("blur", this.validate);
            this.#input.removeEventListener("change", this.validate);
            this.#input.remove();
        }
        this.shadowRoot.innerHTML = "";
    }

    /**
     * Set country using the mapped country code
     * @param {string} countryCode - ISO 3166-1 alpha-3 country code (e.g., 'USA', 'CAN')
     */
    setCountry(countryCode) {
        if (!countryCode || !this.#instance) {
            return;
        }

        const mappedCode = COUNTRY_CODE_MAP[countryCode];
        if (mappedCode) {
            this.#instance.setCountry(mappedCode);
        } else {
            console.warn(`Unknown country code: ${countryCode}`);
        }
    }

    /**
     * Get the current selected country dial code (e.g., '+1')
     * @returns {string} The current country dial code
     */
    getDialCode() {
        if (!this.#instance) {
            return "";
        }
        return this.#instance.getSelectedCountryData()?.dialCode
            ? `+${this.#instance.getSelectedCountryData().dialCode}`
            : "";
    }

    /**
     * Get the current value
     * @returns {string} The current input value
     */
    get value() {
        if (!this.#instance) {
            return "";
        }
        return this.#instance.getNumber();
    }

    /**
     * Set the current value
     * @param {string} value - The value to set
     */
    set value(value) {
        if (this.#instance) {
            this.#instance.setNumber(value || "");
        }
    }

    /**
     * Get the name attribute
     * @returns {string} The name attribute
     */
    get name() {
        return this.getAttribute("name") || "";
    }

    /**
     * Check if the current phone number is valid
     * @returns {boolean} Whether the phone number is valid
     */
    isValid() {
        if (!this.#instance) {
            return false;
        }

        // If no value, check if field is required
        if (!this.value || this.value.trim() === "") {
            return !this.hasAttribute("required");
        }

        // Use intl-tel-input's validation
        return this.#instance.isValidNumber();
    }

    /**
     * Validate the phone input
     * @returns {boolean} Whether the field is valid
     */
    validate() {
        // Clear any existing errors first
        this.clearError();

        // Check phone validation (only if there's a value)
        if (!this.isValid()) {
            this.showError("Invalid phone number");
            return false;
        }

        return true;
    }

    /**
     * Show error message for the phone input
     * @param {string} message - The error message to display
     */
    showError(message) {
        // Find the parent element that should contain the error
        const parentElement = this.parentElement;
        if (!parentElement) return;

        // Look for existing error span or create one
        let errorSpan = parentElement.querySelector(".error");
        if (!errorSpan) {
            // Look for a label that might contain an error span
            const label = parentElement.querySelector(
                `label[for="${this.name}"]`
            );
            if (label) {
                errorSpan = label.querySelector(".error");
                if (!errorSpan) {
                    errorSpan = document.createElement("span");
                    errorSpan.className = "error";
                    label.appendChild(errorSpan);
                }
            } else {
                // Create error span as sibling
                errorSpan = document.createElement("span");
                errorSpan.className = "error";
                parentElement.appendChild(errorSpan);
            }
        }

        // Set error message and add error class to this element
        errorSpan.textContent = message;
        this.classList.add("is-invalid");
    }

    /**
     * Clear error message for the phone input
     */
    clearError() {
        // Remove error class from this element
        this.classList.remove("is-invalid");

        // Find and clear error message
        const parentElement = this.parentElement;
        if (!parentElement) return;

        // Look for error span in label or parent
        const label = parentElement.querySelector(`label[for="${this.name}"]`);
        const errorSpan =
            label?.querySelector(".error") ||
            parentElement.querySelector(".error");

        if (errorSpan) {
            errorSpan.textContent = "";
        }
    }
}

// Register the web component
if (!customElements.get("intl-phone-input")) {
    customElements.define("intl-phone-input", IntlPhoneInput);
}

export default IntlPhoneInput;
